import { render, staticRenderFns } from "./program_pembangunan.vue?vue&type=template&id=5fc7acca&"
import script from "./program_pembangunan.vue?vue&type=script&lang=js&"
export * from "./program_pembangunan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports